module.exports = __webpack_public_path__ + "img/flyer_04.43210f83.jpeg";